import React from 'react';
import { useParams } from 'react-router-dom';
import { useAdminQuoteDetail } from '../../hooks/useAdminQuoteDetail';
import { AdminQuoteDetail } from '../../components/admin/QuoteDetail';

export const QuoteDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const detailProps = useAdminQuoteDetail(id);

  return <AdminQuoteDetail {...detailProps} />;
};
